import { render, staticRenderFns } from "./AllowedStages.vue?vue&type=template&id=844525f4"
import script from "./AllowedStages.vue?vue&type=script&lang=js"
export * from "./AllowedStages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports